module.exports = __webpack_public_path__ + "img/W-G24.81a16c7c.jpg";